module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-8.75ad0ad2.mp3";